import { createSlice } from "@reduxjs/toolkit";
import { initialAICodingState, PageContextOfAICodingFilter, AICodingFilter } from "./aiCodingState";
import { LoadingState } from "types";
import { addV1Reducers } from "./aiCoding.v1";
import { addV2Reducers } from "./aiCoding.v2";


const aiCodingSlice = createSlice({
  name: "aiCoding",
  initialState: initialAICodingState,
  reducers: {
    resetAddAICodingJobOpenedState: (state) => {
      state.isAddAICodingJobOpened = false;
    },
    setAddAICodingJobOpenedState: (state, { payload }: { payload: boolean }) => {
      state.isAddAICodingJobOpened = payload;
    },
    resetCreateAICodingJobState: (state) => {
      state.createAICodingJobState = LoadingState.idle;
      state.createdJobConfigId = undefined;
    },
    toggleJobInfoExpanded: (state) => {
      if(state.variableItemVM) {
        state.variableItemVM.isExpanded = !state.variableItemVM.isExpanded;
      }
    },
    setAICodingPageContext: (
      state,
      { payload }: { payload: { pageContext: PageContextOfAICodingFilter; isPageChanged?: boolean } },
    ) => {
      const isPageChanged = payload.isPageChanged;
      const pageContext = payload.pageContext;
      state.pageContext = isPageChanged ? { ...state.pageContext, page: pageContext.page } : pageContext;
    },
    setAICodingFilters: (state, { payload }: { payload: { [key in keyof AICodingFilter]: string[] } }) => {
      state.filters = { ...state.filters, ...payload };
    },
    resetAICodingFilters: (state) => {
      state.filters = undefined;
    },
  },
  extraReducers: (builder) => {
    addV1Reducers(builder);
    addV2Reducers(builder);
  },
});

export const { 
  setAddAICodingJobOpenedState, 
  resetAddAICodingJobOpenedState, 
  resetCreateAICodingJobState,
  setAICodingPageContext,
  setAICodingFilters,
  resetAICodingFilters,
  toggleJobInfoExpanded,
} = aiCodingSlice.actions;
export default aiCodingSlice.reducer;
